<div class="main px-5">
  <div class="col-12 mt-3 py-2 px-5 bg-light-color" [class.d-none]="route.children.length !== 0">
    <div class="row row-cols-1 row-cols-sm-2 py-4">
      <div class="col-12 d-flex mt-3 justify-content">
        <div class="col d-flex align-items-center">
          <h1 class="fs-4 fw-bold text-primary-color my-0">Lista de Parametrizações</h1>
        </div>
      </div>
      <div class="form-group d-flex justify-content-end ml-3">
        <button nz-button type="button" nzType="primary" [nzSize]="size" class="rounded-pill mt-4 me-3"
          form="vinculoFilterForm" (click)="pesquisar()">
          Pesquisar
        </button>
      </div>
    </div>

    <nz-divider class="m-0 p-0 mb-4 mt-4"></nz-divider>

    <div class="d-flex">
      <div class="col-12 contrato-content pl-0 pr-0 border-gray box-shadow">
        <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
        (nzQueryParams)="sort($event)" [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate"
        [nzScroll]="{ x: 'max-content' }">
          <thead>
            <tr>
              <th nzColumnKey="nome"  nzWidth="25%" nzShowSort [nzSortFn]="true">Nome</th>
              <th nzColumnKey="value"  nzWidth="25%" nzShowSort [nzSortFn]="true" >Valor</th>
              <th nzColumnKey="descricao"  nzWidth="50%" nzShowSort [nzSortFn]="true">Descrição</th>
              <th class="text-center" nzWidth="80px" [nzRight]="true">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of dataSet">
              <td>{{ item.nome }}</td>
              <td>{{item.value}}</td>
              <td>{{ item.descricao }}</td>
              <td class="text-center" [nzRight]="true">
                            <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                  <span nz-icon nzType="more"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li nz-menu-item type="button" (click)="editar(item,item.id!)">
                      <a>Editar</a>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <ng-template #footerTemplate>
          <section class="d-flex justify-content-end w-100">
            <app-pagination [itemPorPagina]="10"></app-pagination>
          </section>
        </ng-template>

        <ng-template #semDadosTemplate>
          <div class="d-flex align-items-center justify-content-center" *ngIf="!parametrizacoes?.length">
            <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div>
  <router-outlet></router-outlet>
</div>
